// extracted by mini-css-extract-plugin
export default {"root":"styles_root__sgM1B","checked":"styles_checked__qs+9n","spin":"styles_spin__F2gzQ"};